export const filterTypesToColumnTypes = {
    DateFilter: ["DateTime", "DateTimeOffset"],
    NumericFilter: ["Int", "Double", "IDInt"],
    TextFilter: ["Text"],
    BooleanFilter: ["Bool"],
};
